import { Button } from '@/components/Button';
import { apiPostRequest } from '@/utils/apiClient';
import { ReactElement, useEffect, useState } from 'react';
import transitionToExternalSite from '@/assets/images/common/transition-to-external-site.png';
import { useTranslation } from 'react-i18next';

function ManageSubscriptionsButton({
    subscriptionStatus,
}: {
    subscriptionStatus: string;
}): ReactElement {
    const [customerPortalUrl, setCustomerPortalUrl] = useState('');
    const { t } = useTranslation('settings');

    // メイン処理
    useEffect(() => {
        const fetchPortalUrl = async () => {
            // サブスクリプション管理URL取得
            const response = await apiPostRequest('/api/payment/stripe/manage-subscriptions', {});
            const data = await response.json();
            setCustomerPortalUrl(data.url);
        };
        fetchPortalUrl();
    }, [subscriptionStatus]);

    // ボタン押下
    const handleManageSubscriptions = () => {
        // Stripeのサブスクリプション管理ページへリダイレクト
        window.open(customerPortalUrl, '_blank');
    };

    return (
        <div>
            {customerPortalUrl !== '' && (
                <>
                    <p className="text-sm text-gray-500">{t('subscription.help')}</p>
                    <Button
                        variant="outline"
                        className="w-72 mt-3 gap-3"
                        onClick={handleManageSubscriptions}
                    >
                        {t('subscription.button')}
                        <img src={transitionToExternalSite} className="size-4 image-protection" />
                    </Button>
                </>
            )}
        </div>
    );
}

export default ManageSubscriptionsButton;
